export const LIST_ALL_VIDEO_ACADEMY = "LIST_ALL_VIDEO_ACADEMY";
export const SUBMIT_TEST = "SUBMIT_TEST";
